export default "__VITE_PUBLIC_ASSET__ed0a04a8__"